import { Component, Input, OnInit } from '@angular/core';
import { MenuI, MenuItems } from 'src/app/core/data/menu';
import { AccountService } from 'src/app/core/services/account.service';
import {
  IonicModule,
  LoadingController,
  MenuController,
  ModalController,
  PopoverController,
} from '@ionic/angular';
import { AppThemeService } from 'src/app/core/services/apptheme.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  menuItems: MenuI[] = MenuItems;
  @Input() contentId = 'header-content';
  sideMenu = false;

  constructor(
    private account: AccountService,
    private menuCtrl: MenuController,
    private themeService: AppThemeService
  ) {}

  get logo() {
    //return this.defaultLogo;
    return this.themeService.getLogo;
  }

  get isCustomDomain() {
    return false;
  }

  get shortName() {
    return 'NYGA';
  }

  ngOnInit() {}

  toggleMenu() {
    this.sideMenu = !this.sideMenu;
  }
}
